// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"360":"958d3232","477":"8a5d953e","531":"adea1a93","716":"76c0b3f5"}[chunkId] + ".css";
};